import { object, string } from 'yup';
import i18n from '../../../i18n';

// Types
import { BudgetCategoryManagement } from './types';

export const BudgetCategoryManagementSchema = object<BudgetCategoryManagement>({
  code: string()
    .required(() => i18n.t('validation:required'))
    .matches(/^\d+$/, () => 'El código debe contener solo números')
    .min(1, () => 'El código debe tener al menos 1 dígito')
    .max(3, () => 'El código no puede tener más de 3 dígitos'),
  name: string()
    .required(() => i18n.t('validation:required'))
    .min(3, () => 'El nombre debe tener al menos 3 caracteres')
    .max(100, () => 'El nombre no puede tener más de 100 caracteres'),
  color: string()
    .required(() => i18n.t('validation:required'))
    .matches(
      /^#[0-9A-Fa-f]{6}$/,
      () => 'El color debe ser un código hexadecimal válido (#RRGGBB)'
    ),
});

